import {IconDefinition} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Group, Menu} from '@mantine/core';
import {FC, useCallback, useMemo} from 'react';
import {
  ProtectedElement,
  useRequireAuthorizationProps,
} from '../auth/require-authorization';
import {
  navLinkCss,
  PrimaryNavLink,
  PrimaryNavLinkProps,
} from './primary-nav-link';

export type SubNavMenuProps = {
  icon: IconDefinition;
  data: PrimaryNavLinkProps[];
  title: string;
  authProps?: useRequireAuthorizationProps;
};

export const SubNavMenu: FC<SubNavMenuProps> = ({
  icon,
  data,
  title,
  authProps,
}) => {
  const mapFn = useCallback((item: PrimaryNavLinkProps, index: number) => {
    const {authProps: itemAuthProps} = item;
    const menuItem = (
      <Menu.Item pl={32} pr={32} key={index}>
        <PrimaryNavLink {...item} />
      </Menu.Item>
    );

    return itemAuthProps ? (
      <ProtectedElement {...itemAuthProps} key={index}>
        {menuItem}
      </ProtectedElement>
    ) : (
      <>{menuItem}</>
    );
  }, []);

  const items = useMemo(
    () => data.map(mapFn).filter((x) => x !== null),
    [data, mapFn]
  );

  return authProps ? (
    <ProtectedElement {...authProps}>
      <Menu trigger="hover" openDelay={100} closeDelay={400}>
        <Menu.Target css={navLinkCss}>
          <Group gap={'xs'}>
            <FontAwesomeIcon icon={icon} /> {title}
          </Group>
        </Menu.Target>
        <Menu.Dropdown>{items}</Menu.Dropdown>
      </Menu>
    </ProtectedElement>
  ) : null;
};
